import library from '../../../src/data/roleLibrary.json' with { type: 'json' };
import supplementalRoles from '../../../src/data/additionalCanonicalRoles.json' with { type: 'json' };

const titleFromKey = key => key.replaceAll('_', ' ').replace(/\b\w/g, c => c.toUpperCase());

export const categoryLabels = {
  medical: 'Doctors',
  nursing: 'Nursing & Midwifery',
  allied_health: 'Allied Health Professionals',
  pharmacy: 'Pharmacy',
  diagnostics: 'Diagnostics & Laboratories',
  dental: 'Dental',
  theatre_critical_care: 'Theatre & Critical Care',
  community: 'Community Services',
  mental_health: 'Mental Health',
  administration: 'Patient Support & Administration',
  support: 'Facilities & Support',
  research: 'Research'
};

const canonicalRoles = [...(library.roles || []), ...(supplementalRoles || [])];

export const roles = canonicalRoles
  .map(role => {
    const shared = role.knowledge?.shared || {};
    const presentation = shared.presentation || {};
    const patient = role.knowledge?.patient || {};
    const title = presentation.title || presentation.plainEnglishTitle || titleFromKey(role.roleKey);
    const plainEnglishTitle = presentation.plainEnglishTitle || presentation.title || title;
    return {
      ...role,
      title,
      plainEnglishTitle,
      content: patient.content || {},
      patientStatus: patient.status || role.status,
      patientFacingEnabled: patient.patientFacingEnabled !== false,
      sourceSystem: shared.sourceSystem || 'canonical',
      presentation,
      journeyTags: shared.journeyTags || role.journeyTags || [],
      careSettings: shared.careSettings || role.careSettings || [],
      tags: shared.tags || role.tags || [],
      categoryLabel: categoryLabels[role.category] || titleFromKey(role.category || 'other')
    };
  })
  .sort((a, b) => a.title.localeCompare(b.title));

export const roleByKey = new Map(roles.map(role => [role.roleKey, role]));

export const roleGroups = Object.entries(
  roles.reduce((groups, role) => {
    (groups[role.category] ||= []).push(role);
    return groups;
  }, {})
)
  .map(([category, groupRoles]) => ({
    category,
    label: categoryLabels[category] || titleFromKey(category),
    roles: groupRoles
  }))
  .sort((a, b) => {
    if (a.category === 'medical') return -1;
    if (b.category === 'medical') return 1;
    return a.label.localeCompare(b.label);
  });

export const doctorRoles = roles.filter(role => role.category === 'medical');
export const libraryMeta = {
  schemaVersion: library.schemaVersion,
  libraryVersion: library.libraryVersion,
  targetRoleCount: library.targetRoleCount,
  supplementalRoleCount: supplementalRoles.length,
  totalRoleCount: roles.length,
};
